import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-brand-section">
          <h3>The Half Time Whistle</h3>
          <p>
            Inspiring families to pause, wander, and explore the world through authentic road trips,
            hidden gems, and local travel experiences.
          </p>
        </div>
        
        <div className="footer-links-section">
          <h4>Continents</h4>
          <ul>
            <li><Link to="/northamerica">North America</Link></li>
            <li><Link to="/centralamerica">Central America</Link></li>
            <li><Link to="/europe">Europe</Link></li>
            <li><Link to="/asia">Asia</Link></li>
            <li><Link to="/oceania">Oceania</Link></li>
          </ul>
        </div>

        <div className="footer-links-section">
          <h4>Tools & LLM</h4>
          <ul>
            <li><a href="/sitemap.xml" target="_blank" rel="noreferrer">XML Sitemap</a></li>
            <li><a href="/llms.txt" target="_blank" rel="noreferrer">LLM AI Manifest</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} TheHalfTimeTravel and TheHalfTimeWhistle Website. All rights reserved.</p>
        <p className="disclaimer">Disclaimer: All images and content represent our personal opinion and perspective.</p>
      </div>
    </footer>
  );
};

export default Footer;
